module.exports = __webpack_public_path__ + "media/bootstrap-icons/segmented-nav-e0646f5e.svg";